export default __webpack_public_path__ + "static/media/working-with-us-mobile.3d782aed.jpg";